import appConfig from "../config.js";

/**
 * The completions endpoint the chat sends a question to, relative to /agents/{id}/.
 *
 * V2 = the same contract as /completions, plus the agent's LLM Schema answer format when its
 * settings select it (discover api/apps/sdk/session.py). Off by default:
 * REACT_APP_COMPLETIONS_V2_ENABLED turns it on per environment. Takes no argument on
 * purpose: the flag lives on the app config only, and ChatScreen's `config` is the selected
 * agent's config, which has no feature flags.
 */
export const completionsPath = () =>
  appConfig.completionsV2Enabled ? "completions/v2" : "completions";
